import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { CalendarDays, Download } from "lucide-react";

const sportsAchievements = [
  {
    slug: "table-tennis-women-2024",
    title: "Women's Table Tennis Team",
    subtitle: "VTU Belagavi Division Inter Collegiate Table Tennis Tournament",
    year: "2024",
    description:
      "Secured 2nd Place at KLS VDIT Campus and earned the opportunity to compete at the state level held at VVCE Mysuru.",
    image: "/life/sports/2024/table-tennis-women.jpg",
    tournament:
      "VTU Belagavi Division Inter Collegiate Table Tennis Tournament",
    date: "1st & 2nd July 2024",
    location: "KLS VDIT Campus",
    position: "Runner-Up",
    summary:
      "The institute's Women's Table Tennis Team delivered a strong performance at the VTU Belagavi Division tournament, earning second place and qualifying for the state level competition at VVCE Mysuru.",
    students: [
      ["1", "Sanjana S S", "2VD21EC0832", "VI"],
      ["2", "Sneha S M", "2V22DME443", "VI"],
      ["3", "Priya M H", "2VD22CS038", "IV"],
      ["4", "Amrita M O", "2VD23EC013", "II"],
    ],
  },
  {
    slug: "karate-men-2024",
    title: "Men's Karate Team",
    subtitle: "VTU State Level Inter Collegiate Karate Competition",
    year: "2024",
    description:
      "Participants secured two bronze finishes at BIT Bengaluru in the 60kg and 84kg categories.",
    image: "/life/sports/2024/karate-men.jpg",
    tournament: "VTU State Level Inter Collegiate Karate Competition",
    date: "26 September 2024",
    location: "BIT Bengaluru",
    position: "Bronze medals in two weight categories",
    summary:
      "The institute's men's karate team produced medal-winning performances in the state level inter collegiate competition at BIT Bengaluru.",
    students: [
      ["1", "Vinayak M B", "2VD22ME056", "VI"],
      ["2", "Pancham S S", "2VD23CI026", "III"],
    ],
  },
  {
    slug: "kabaddi-men-2024",
    title: "Men's Kabaddi Team",
    subtitle: "VTU Belagavi Division Inter Collegiate Kabaddi Tournament",
    year: "2024",
    description:
      "Runner-Up at VSMSRKIT Nipani and earned the opportunity to compete at the state level held at CIT Gubbi.",
    image: "/life/sports/2024/kabaddi-men.jpg",
    tournament: "VTU Belagavi Division Inter Collegiate Kabaddi Tournament",
    date: "18th & 19th October 2024",
    location: "VSMSRKIT Nipani",
    position: "Runner-Up",
    summary:
      "The institute's men's kabaddi squad finished runner-up in the VTU Belagavi Division event and advanced to the state level tournament at CIT Gubbi.",
    students: [
      ["1", "Suraj P M", "2VD22EC111", "V"],
      ["2", "Manikanth M", "2VD20EC050", "VII"],
      ["3", "Kuladeep N D", "2VD24ME423", "III"],
      ["4", "Shanmukh C G", "2VD24ME404", "III"],
      ["5", "Ashwat R P", "2VD23ME001", "III"],
      ["6", "Vishal P M", "2VD23ME009", "III"],
      ["7", "Girish A P", "2VD23ME407", "V"],
      ["8", "Vinayak T P", "2VD24 ME430", "III"],
      ["9", "Mallikarjun K A", "2VD23EE014", "III"],
      ["10", "Sagar P S", "2VD22ME006", "V"],
      ["11", "Gangadhar H", "2VD22EC038", "V"],
      ["12", "Praveen S B", "2VD24ME429", "III"],
    ],
  },
  {
    slug: "basketball-women-2024",
    title: "Women's Basketball Team",
    subtitle:
      "VTU Rest of Bengaluru Division Inter Collegiate Basketball Tournament",
    year: "2024",
    description:
      "Finished 4th place at KLS VDIT Campus with a strong display of teamwork and earned the opportunity to compete at the state level held at RVIT Bengaluru.",
    image: "/life/sports/2024/basketball-women.jpg",
    tournament:
      "VTU Rest of Bengaluru Division Inter Collegiate Basketball Tournament",
    date: "5th & 6th November 2024",
    location: "KLS VDIT Campus",
    position: "4th Place",
    summary:
      "The institute's women's basketball team achieved a fourth-place finish in the inter collegiate division tournament, demonstrating excellent coordination and athleticism.",
    students: [
      ["1", "Supritha V H", "2VD22CS059", "V"],
      ["2", "Shrilakshmi M", "2VD22CI054", "V"],
      ["3", "Uma H", "Roll No. 356", "I"],
      ["4", "Soubhagya S A", "2VD22CI059", "V"],
      ["5", "Sneha R D", "Roll No. 333", "I"],
      ["6", "Nikhita S K", "2VD22CS029", "V"],
      ["7", "Shravani V S", "Roll No.346", "I"],
      ["8", "Megha M P", "2VD23CV417", "V"],
      ["9", "Sanjana D", "2VD23CI045", "III"],
    ],
  },
  {
    slug: "volleyball-men-2024",
    title: "Men's Volleyball Team",
    subtitle: "VTU Belagavi Division Inter Collegiate Volleyball Tournament",
    year: "2024",
    description:
      "Secured 2nd place at TCE Gadag and advanced to the state level round at MIT Mysuru.",
    image: "/life/sports/2024/volleyball-men.png",
    tournament: "VTU Belagavi Division Inter Collegiate Volleyball Tournament",
    date: "19th & 20th November 2024",
    location: "TCE Gadag",
    position: "Runner-Up",
    summary:
      "The institute's men's volleyball team secured a runner-up position in the VTU Belagavi Division tournament and earned the opportunity to compete at the state level held at MIT Mysuru.",
    students: [
      ["1", "Atiqur R Sayed", "2VD21EC021", "7"],
      ["2", "Naveen B B", "2VD21EC056", "7"],
      ["3", "Prashant R K", "2VD21EC066", "7"],
      ["4", "Rakshit G G", "2VD21ME012", "7"],
      ["5", "Sahil M K", "2VD22CV419", "7"],
      ["6", "Akeebahmed", "2VD23CV406", "5"],
      ["7", "Md Ujefa S K", "2VD22CI020", "5"],
      ["8", "Sheetal B P", "2VD22EC097", "5"],
      ["9", "Akash B G", "2VD23EC008", "3"],
      ["10", "Rihanbaksh A S", "2VD23EC078", "3"],
      ["11", "Numan M D", "Roll.318", "1"],
      ["12", "Prathvi S V", "Roll.720", "1"],
    ],
  },
  {
    slug: "throw-ball-women-2023",
    title: "Women's Throw Ball Team",
    subtitle: "VTU Belagavi Division Inter Collegiate Throw Ball Tournament",
    year: "2023",
    description: "Secured 4th Place at SKSVMA CET Laxmeshwar.",
    image: "/life/sports/2023/throwball-women.jpg",
    tournament: "VTU Belagavi Division Inter Collegiate Throw Ball Tournament",
    date: "13th & 14th March 2023",
    location: "SKSVMA CET Laxmeshwar",
    position: "4th Place",
    summary:
      "The institute's Women's Throw Ball Team participated with excellent teamwork in the VTU Belagavi Division tournament.",
    students: [
      ["1", "Queeni F", "2VD19EC061"],
      ["2", "Veena S", "2VD19EE027"],
      ["3", "Tunga R", "2VD19EC086"],
      ["4", "Sakshi D", "Roll no: 225"],
      ["5", "Priya H", "Roll no: 437"],
      ["6", "Poorvi V", "Roll no: 204"],
      ["7", "Anusha G", "Roll no: 306"],
      ["8", "Mamatha L", "Roll no: 420"],
      ["9", "Laxmi C", "2VD20CS015"],
      ["10", "Jahanvi M", "Roll no: 602"],
      ["11", "Soniya C", "Roll no: 241"],
      ["12", "Sahitya S", "Roll no: 223"],
    ],
  },
  {
    slug: "kho-kho-men-2023",
    title: "Men's Kho-Kho Team",
    subtitle: "VTU Belagavi Division Inter Collegiate Kho-Kho Tournament",
    year: "2023",
    description:
      "Secured Runner-Up position and qualified for State Level at KIT Tiptur.",
    image: "/life/sports/2023/khokho-men.png",
    tournament: "VTU Belagavi Division Inter Collegiate Kho-Kho Tournament",
    date: "20th & 21st March 2023",
    location: "HIT Nidasoshi",
    position: "Runner-Up",
    summary:
      "The institute's Men's Kho-Kho Team delivered an outstanding performance, securing runner-up position and participated in a state level competition held at KIT Tiptur.",
    students: [
      ["1", "Tirumal R M", "2VD19CV042"],
      ["2", "Raghunath M D", "2VD20ME427"],
      ["3", "Dileep B G", "2VD20EC016"],
      ["4", "Malatesh S M", "2VD19CS021"],
      ["5", "Nikil B C", "2VD21ME411"],
      ["6", "Shashank N", "2VD20CV022"],
      ["7", "Gangadhar H", "Roll No 137"],
      ["8", "Akshay S", "Roll no.112"],
      ["9", "Sumit G R", "2VD19ME046"],
      ["10", "Deelip W", "Roll no.313"],
      ["11", "Maruti B G", "Roll no.322"],
      ["12", "Sachin S N", "Roll no.442"],
    ],
  },
  {
    slug: "netball-men-2023",
    title: "Men's Net Ball Team",
    subtitle:
      "VTU Rest of Bengaluru Division Inter Collegiate Net Ball Tournament",
    year: "2023",
    description:
      "Participated in VTU Rest of Bengaluru Division Inter Collegiate Net Ball Tournament.",
    image: "/life/sports/2023/netball-men.jpg",
    tournament:
      "VTU Rest of Bengaluru Division Inter Collegiate Net Ball Tournament",
    date: "29th March 2023",
    location: "St. Joseph Engineering College, Mangalore",
    position: "Participation",
    summary:
      "The institute's Men's Net Ball Team demonstrated competitive spirit and skill in the inter collegiate division tournament.",
    students: [
      ["1", "Anirudh Patil", "Roll no.118"],
      ["2", "Abhishek V", "Roll no.403"],
      ["3", "Samarth S K", "Roll no.540"],
      ["4", "Sujal C Akki", "Roll no.339"],
      ["5", "Nuthan K B", "Roll no.159"],
      ["6", "Rajesh S Meti", "Roll no.215"],
      ["7", "Mhd Hujefa S K", "Roll no.520"],
      ["8", "Shivaprasad D K", "Roll no.546"],
      ["9", "Sheetal B Patil", "Roll no.323"],
      ["10", "Nandana S H", "Roll no.161"],
      ["11", "Praveen k", "Roll no.209"],
      ["12", "Vinayak S G", "Roll no.442"],
    ],
  },
  {
    slug: "kho-kho-men-2025-26",
    title: "Men's Kho-Kho Team",
    subtitle: "VTU Belagavi Division Inter Collegiate Kho-Kho Tournament",
    year: "2025-26",
    description:
      "Runner-Up at VTU Belagavi Division Inter Collegiate Kho-Kho Tournament.",
    image: "/life/sports/2025-26/khokho-men.jpg",
    tournament: "VTU Belagavi Division Inter Collegiate Kho-Kho Tournament",
    date: "29th & 30th April 2025",
    location: "KLS VDIT Campus",
    position: "Runner-Up",
    summary:
      "The institute's Men's Kho-Kho Team secured runner-up position in the VTU Belagavi Division Inter Collegiate Kho-Kho tournament held at KLS VDIT Campus.",
    students: [
      ["1.", "Md Yasin Baig M S", "2VD22EC404", "8th"],
      ["2.", "Sachin S Naikar", "2VD22CS043", "6th"],
      ["3.", "Maruti B Goudar", "2VD22EE021", "6th"],
      ["4.", "Gangadhar Hongal", "2VD22EC038", "6th"],
      ["5.", "Akshay Sheelimath", "2VD22EC012", "6th"],
      ["6.", "Dileep B Walekar", "2VD22EE013", "6th"],
      ["7.", "Chetan S Ghadi", "2VD24CV406", "4th"],
      ["8.", "Prajwal Pawar", "2VD23EE028", "4th"],
      ["9.", "Rushikesh Shinde", "2VD23ME414", "6th"],
      ["10.", "Nikhil Mirajakar", "2VD23EC056", "4th"],
      ["11.", "Girish Hadapad", "2VD23EE011", "4th"],
      ["12.", "Shrishail Warad", "2VD24EE048", "2nd"],
      ["13.", "Manesh M V", "2VD24CS048", "2nd"],
      ["14.", "Agadish Kedari Chipati", "2VD23ME408", "6th"],
      ["15.", "Praveen Dhanaji Kadam", "2VD23EE031", "4th"],
    ],
  },
  {
    slug: "badminton-men-2025",
    title: "Men's Shuttle Badminton Team",
    subtitle:
      "VTU Belagavi Division Inter Collegiate Shuttle Badminton Tournament",
    year: "2025",
    description:
      "Runner-Up at VTU Belagavi Division and competed in State Level at PES Mandya.",
    image: "/life/sports/2025-26/badminton-men.jpg",
    tournament:
      "VTU Belagavi Division Inter Collegiate Shuttle Badminton Tournament",
    date: "8th & 9th September 2025",
    location: "VTU Campus Belagavi",
    position: "Runner-Up",
    summary:
      "The institute's Men's Badminton Team achieved runner-up position in the VTU Belagavi Division tournament and qualified for the State Level competition at PES Mandya.",
    students: [
      ["1.", "Abhishek V H", "2VD22CS003", "7th"],
      ["2.", "Abhishek b", "2VD23EC003", "5th"],
      ["3.", "Yashpratap singh", "2VD23EC124", "5th"],
      ["4.", "Aditya patil", "2VD23CI005", "5th"],
      ["5.", "Om Sing", "2VD24EC050", "3rd"],
    ],
  },
  {
    slug: "table-tennis-2025",
    title: "Table Tennis Men & Women Team",
    subtitle: "VTU Belagavi Division Inter Collegiate Table Tennis Tournament",
    year: "2025",
    description:
      "Runner-Up at VTU Belagavi Division and earned the opportunity to compete at the state level held at BMS College Bengaluru.",
    image: "/life/sports/2025-26/table-tennis-women.jpg",
    tournament:
      "VTU Belagavi Division Inter Collegiate Table Tennis Tournament",
    date: "15th September 2025",
    location: "KLS VDIT Campus",
    position: "Runner-Up",
    summary:
      "The institute Table Tennis Men & Women Team secured runner-up position in the VTU Belagavi Division tournament and advanced to the State Level competition at BMS Bengaluru.",
    students: [
      ["1.", "Yashpratap singh", "2VD23EC124", "5th"],
      ["2.", "Shreyas V N", "2VD22CV005", "7th"],
      ["3.", "Shashank S U", "2VD24CS090", "3rd"],
      ["4.", "Anurag D Dindalkopp", "2VD22EC019", "7th"],
      ["5.", "Joshi Kushal Sudhir", "2VD24ME414", "7th"],
      ["6.", "Priya M H", "2VD22CS038", "7th"],
      ["7.", "Amrita M O", "2VD23EC013", "5th"],
      ["8.", "Sana Jeelani I H", "2VD24ME441", "5th"],
      ["9.", "Srushti G G", "1st Year", "1st"],
    ],
  },
  {
    slug: "wrestling-judo-2025",
    title: "Wrestling & Judo Team",
    subtitle: "VTU State Level Wrestling & Judo Competition",
    year: "2025",
    description: "Silver and Bronze Medal winners at VTU State Level.",
    image: "/life/sports/2025-26/wrestling-judo.jpg",
    tournament: "VTU State Level Wrestling & Judo Men and Women Competition",
    date: "17th to 19th October 2025",
    location: "MIT Mysuru",
    position: "Silver & Bronze Medals",
    summary:
      "The institute's Wrestling & Judo team produced medal-winning performances with Silver and Bronze medals secured at the VTU State Level Competition.",
    students: [
      ["1", "Shanamukh C G", "2VD24ME444", "5th", "Silver - 74kg"],
      ["2", "Ekanath T B", "2VD25EC050-T", "1st Year", "Bronze - 61kg"],
      ["3", "Aishwarya H M", "2VD24EE400", "5th", "Bronze - 53kg"],
    ],
  },
  {
    slug: "karate-2025",
    title: "Karate Men Competition",
    subtitle: "VTU State Level Inter Collegiate Karate Tournament",
    year: "2025",
    description: "Bronze Medal winners at VTU State Level Karate Competition.",
    image: "/life/sports/2025-26/karate-men.jpg",
    tournament: "VTU State Level Karate Men Competition",
    date: "17th & 19th October 2025",
    location: "RVIT Bengaluru",
    position: "Bronze Medals",
    summary:
      "The institute's Karate team secured bronze medals at the VTU State Level Inter Collegiate Competition held at RVIT Bengaluru.",
    students: [
      ["1", "Pancham S S", "2VD23CI026", "5th", "Bronze - 84kg"],
      ["2", "Malik Rehan Kittur", "2VD26CV403", "3rd", "Bronze - 67kg"],
    ],
  },
];

export const getSportsAchievementBySlug = (slug) =>
  sportsAchievements.find((achievement) => achievement.slug === slug);

export const getAllSportsAchievements = () =>
  [...sportsAchievements].sort(
    (first, second) => getSortDate(second) - getSortDate(first),
  );

const monthNumbers = {
  january: 0,
  february: 1,
  march: 2,
  april: 3,
  may: 4,
  june: 5,
  july: 6,
  august: 7,
  september: 8,
  october: 9,
  november: 10,
  december: 11,
};

const getSortDate = ({ date, year }) => {
  const dateText = date.toLowerCase();
  const monthMatch = dateText.match(
    /\b(january|february|march|april|may|june|july|august|september|october|november|december)\b/,
  );
  const dayMatches = [...dateText.matchAll(/\b(\d{1,2})(?:st|nd|rd|th)?\b/g)];
  const yearMatch = dateText.match(/\b(20\d{2})\b/);

  const parsedYear = yearMatch
    ? Number.parseInt(yearMatch[1], 10)
    : Number.parseInt(year, 10);
  const parsedMonth = monthMatch ? monthNumbers[monthMatch[1]] : 0;
  const parsedDay = dayMatches.length
    ? Number.parseInt(dayMatches[dayMatches.length - 1][1], 10)
    : 1;

  return new Date(parsedYear || 0, parsedMonth, parsedDay).getTime();
};

const SportsAchievement = ({ section }) => {
  const achievements = getAllSportsAchievements();

  useEffect(() => {
    document.title = "Achievement | KLS VDIT";
    updateMeta(
      "description",
      section?.summary ||
        "Explore sports achievements from KLS VDIT students in VTU tournaments.",
    );
    updateMeta("og:title", "Achievement | KLS VDIT");
    updateMeta(
      "og:description",
      section?.summary ||
        "Explore sports achievements from KLS VDIT students in VTU tournaments.",
    );
  }, [section]);

  return (
    <div className="space-y-4">
      <p className="text-sm leading-relaxed text-left text-[#2a2a2a]/85 [word-spacing:normal]">
        {section?.summary ||
          "KLS VDIT sports teams have performed strongly in VTU Division and State level competitions. Click any achievement to view detailed results and student participation."}
      </p>

      <div className="grid gap-5 md:grid-cols-2">
        {achievements.map((achievement) => (
          <article
            key={achievement.slug}
            className="bg-white border border-brand/15 shadow-sm h-full"
          >
            <Link
              to={`/sports/achievements/${achievement.slug}`}
              className="group flex h-full gap-3 p-5 sm:gap-4 sm:p-6 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand/30"
              aria-label={`View details for ${achievement.title}`}
            >
              <span className="mt-0.5 flex h-10 w-10 flex-none items-center justify-center border border-brand/20 text-brand">
                <CalendarDays size={17} strokeWidth={1.8} />
              </span>

              <div className="min-w-0 flex-1">
                <h3
                  className="text-lg text-brand font-semibold leading-snug"
                  style={{ fontFamily: "'Cormorant Garamond', serif" }}
                >
                  {achievement.title} ({achievement.year})
                </h3>
                <p className="mt-2 text-[15px] text-left text-[#2a2a2a]/85 leading-relaxed [word-spacing:normal]">
                  {achievement.description || achievement.summary}
                </p>
                <span className="mt-5 inline-flex items-center justify-center gap-2 bg-brand px-4 py-2 text-xs font-bold uppercase tracking-normal text-surface transition group-hover:bg-brand-dark">
                  <Download size={13} strokeWidth={2.2} />
                  View Full
                </span>
              </div>
            </Link>
          </article>
        ))}
      </div>
    </div>
  );
};

const updateMeta = (name, content) => {
  if (!content) {
    return;
  }

  const selector = `meta[name='${name}'], meta[property='${name}']`;
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement("meta");
    if (name.startsWith("og:")) {
      element.setAttribute("property", name);
    } else {
      element.setAttribute("name", name);
    }
    document.head.appendChild(element);
  }

  element.setAttribute("content", content);
};

export default SportsAchievement;
